// @ts-strict-ignore
import { ConnectionAreaSearchRequirementsVO } from './connection-area-search-requirements.vo';
import { ConnectionAreaSearchVectorVO } from './connection-area-search-vector.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ConnectionAreaSearchQueryVO')
export class ConnectionAreaSearchQueryVO {

  @JsonProperty('requirements', '[ConnectionAreaSearchRequirementsVO]')
  public requirements: ConnectionAreaSearchRequirementsVO[] = undefined;
  @JsonProperty('searchVectors', '[ConnectionAreaSearchVectorVO]')
  public searchVectors: ConnectionAreaSearchVectorVO[] = undefined;
  @JsonProperty('includedArticleTypes', '[String]')
  public includedArticleTypes: string[] = undefined;
  @JsonProperty('includedArticleIds', '[Number]')
  public includedArticleIds: number[] = undefined;
  @JsonProperty('includedArticleIdsSorted', 'Boolean')
  public includedArticleIdsSorted: boolean = false;
  @JsonProperty('searchByArticles', 'Boolean')
  public searchByArticles: boolean = undefined;
  @JsonProperty('electedArticleIds', '[Number]')
  public electedArticleIds: number[] = null;
  @JsonProperty('accessoryArticleInformationObservedInSearch', 'Boolean')
  public accessoryArticleInformationObservedInSearch: boolean = true;
  // TODO: (from flex) set/use correctly; set to fixed true for testing new multiple placement accessory search for bridges
  @JsonProperty('isSearchForMultiplePlacementsOfResultsInSingleSearchVectorEnabled', 'Boolean')
  public isSearchForMultiplePlacementsOfResultsInSingleSearchVectorEnabled: boolean = false;
  @JsonProperty('searchType', 'String')
  public searchType: string = null;
  @JsonProperty('alternatingJumperUsed', 'Boolean')
  public alternatingJumperUsed: boolean = true;
}
